const getStateAcronym = (state: string) =>
  state.replace(/\b[a-zA-Z]{2}-/g, '').toUpperCase()

export default getStateAcronym
